import { z, ZodType } from 'zod';
import { TurnStatus, turnStatusesSchema } from './turn-status';

export type RefreshTurn = {
	clientSeed: string;
	mines: number[][];
	multiplier: number;
	profit: number;
	provablyFair: string;
	status: TurnStatus;
	turnHistory: number[];
	wager: number;
};

export const refreshTurnSchema: ZodType<RefreshTurn> = z.object({
	clientSeed: z.string(),
	mines: z.number().array().array(),
	multiplier: z.number(),
	profit: z.number(),
	provablyFair: z.string(),
	status: turnStatusesSchema,
	turnHistory: z.number().array(),
	wager: z.number(),
});
